__turbopack_context__.v({
  "content": "ListItem-module__Lq7AvG__content",
  "icon": "ListItem-module__Lq7AvG__icon",
  "item": "ListItem-module__Lq7AvG__item",
  "marker": "ListItem-module__Lq7AvG__marker",
  "ordered": "ListItem-module__Lq7AvG__ordered",
  "outlined": "ListItem-module__Lq7AvG__outlined",
});
